module.exports = __webpack_public_path__ + "static/media/close-circle.9be11078.svg";